module.exports = "https://product-cdn.sandbox.surfline.com/kbyg/_next/static/images/paywall-travel-seasonal-report-4aea30ce348f5dbc5d75baa63354eb23.png";